import React from "react";
import Grid from "@mui/material/Grid";
import { Paper } from "@mui/material";

export default function UserListLabel() {
  return (
    <Paper elevation={0} sx={{ zIndex: 1 }}>
      <Grid container textAlign="center">
        <Grid container sx={{ borderBottom: 1, borderColor: "#4c4c4c" }}>
          <Grid
            item
            xs={1.5}
            marginTop="10px"
            marginBottom="10px"
            sx={{ fontWeight: "bold" }}
            fontSize="14px"
          >
            氏名
          </Grid>
          <Grid
            item
            xs={3}
            marginTop="10px"
            marginBottom="10px"
            sx={{ fontWeight: "bold" }}
            fontSize="14px"
          >
            メールアドレス
          </Grid>
          <Grid
            item
            xs={1}
            marginTop="10px"
            marginBottom="10px"
            sx={{ fontWeight: "bold" }}
            fontSize="14px"
          >
            ユーザ区分
          </Grid>
          <Grid
            item
            xs={2}
            marginTop="10px"
            marginBottom="10px"
            sx={{ fontWeight: "bold" }}
            fontSize="14px"
          >
            作成日
          </Grid>
          <Grid
            item
            xs={1.5}
            marginTop="10px"
            marginBottom="10px"
            sx={{ fontWeight: "bold" }}
            fontSize="14px"
          >
            新着マッチング
          </Grid>
          <Grid
            item
            xs={2}
            marginTop="10px"
            marginBottom="10px"
            sx={{ fontWeight: "bold" }}
            fontSize="14px"
          >
            最終ログイン日時
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
